// Dependencies
import React from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import { setBodyStyleOverflow } from '../../redux/layoutReducer';
import { ThemeContext } from "../theme/Theme.jsx";

// Styles
import './Spinner.scss';

class Spinner extends React.Component {
	static contextType = ThemeContext;
	constructor(props) {
		super(props);
		this.state = {
			waiting: true,
		};
		this.waitingTimeMs = 200;
	}
	componentDidMount() {
		this.timer = setTimeout(() => {
			this.setState(
				{
					waiting: false,
				},
			);
		}, this.waitingTimeMs);
		this.redirectTimer = setTimeout(() => {
			console.warn('timeout, redirect to error page')
			window.location.href = '/error';
		}, 120000);
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
		clearTimeout(this.redirectTimer);
		// this.props.setBodyStyleOverflow();
	}

	render() {
		const text = this.context.themeManager.getThemeTextOrHardcodedDefault('waitingQueueSpinnerText');
		if (!this.state.waiting) {
			return (
				<div className="spinnerContainer">
					{
						(this.props.waitingInQueue) &&
						<div className="spinner__text" dangerouslySetInnerHTML={{ __html: text }} />
					}
					<div className="leo_spinner" />
				</div>
			);
		}
		return null;
	}
}

// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state) => {
	const waitingInQueue = state.shoppingCart.waitingInQueue;
	return {
		waitingInQueue,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setBodyStyleOverflow: () => {
		dispatch(setBodyStyleOverflow('auto'));
	},
});

const RadiumSpinner = radium(Spinner);
export default connect(
	mapStateToProps, mapDispatchToProps)(RadiumSpinner);
